import React, {Component} from 'react';
import injectSheet from 'react-jss';
import PropTypes from 'prop-types';

const styles = theme => ({
    headerContainer: {
        cursor: 'pointer',
        paddingBottom: 20
    },
    innerContainer: {
        clear: 'both',
        background: 'white',
        borderStyle: 'solid',
        borderColor: theme.colors.primary,
        marginTop: 10,
        padding: '10px 20px'
    },
    label: {
        float: 'left'
    },
    outerContainer: {
        clear: 'both',
        padding: '5px 10px'
    },
    toggleIcon: {
        cursor: 'pointer',
        float: 'right',
        fontSize: 26
    }
});

class AccordionSection extends Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        isOpen: PropTypes.bool.isRequired,
        label: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired
    };

    handleAccordionToggle = () => {
        const {label, onClick} = this.props;
        onClick(label);
    };

    render() {
        const {props} = this;
        const {children, classes, isOpen, label} = props;
        const toggleIcon = isOpen ? '-' : '+';

        return (
            <div className={classes.outerContainer}>
                <div className={classes.headerContainer} onClick={this.handleAccordionToggle}>
                    <div className={classes.label}>
                        <h4>{label}</h4>
                    </div>
                    <div className={classes.toggleIcon}>
                        <b>{toggleIcon}</b>
                    </div>
                </div>
                {isOpen && (
                    <div className={classes.innerContainer}>
                        {children}
                    </div>
                )}
            </div>
        );
    }
}

export default injectSheet(styles)(AccordionSection);